import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const DepositInfo = styled(Flex)`
  font-weight: bold;
  white-space: nowrap;
  text-transform: uppercase;
  width: inherit;

  ${({ theme }) => css`
    ${theme.media.md.down} {
      justify-content: space-between;
    }

    ${theme.media.md.up} {
      grid-gap: ${theme.spacing(4)};
    }

    border-top: 1px ${theme.colors.primaryAdd6} solid;
    border-bottom: 1px ${theme.colors.primaryAdd6} solid;
    padding: ${theme.spacing(2, 0, 1)};
    margin: ${theme.spacing(2, 0, 1)};

    * {
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.h5};
    }
  `};
`;
